export default __webpack_public_path__ + "d1dfb9a192e9c49da78b0007538e21bc.wav";